export default __webpack_public_path__ + "static/media/cra.32aa9ec5.png";